<template>
  <v-app id="landing-page">
    <v-row align="start" class="mt-12" justify="start">
      <v-col class="mt-10 ml-2 mr-2">
        <loading :active.sync="loading" color="white"></loading>

        <router-view />
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";


export default {
  name: "App",

  components: {
   
    Loading,
    
  },

  computed: {
    ...mapState("auth", ["isLogged", "user", "access_token", "showMenu"]),
    ...mapState([
      "loading",
      "colorBase",
      "colorBoton",
      "colorBotonRed",
      "colorBotonBlue"
    ])
  },

  data: () => ({
    
  }),

  mounted() {
 
  },

  methods: {
     ...mapActions("auth", ["logOut"]),
  }
};
//  background-color: rgb(58, 58, 110);
</script>


<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,300");

.application {
  font-family: "Open Sans";
}

#landing-page {
  background-position: center;
  background-image: url("./assets/fondo13.jpg");

  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
